import { render, staticRenderFns } from "./EstatePlanning.vue?vue&type=template&id=466d9311"
import script from "./EstatePlanning.vue?vue&type=script&lang=js"
export * from "./EstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports